module.exports = __webpack_public_path__ + "img/spartan-carpentry-millwork-cabinetry-07-xxlarge.e52533b4.jpg";